export default "__VITE_ASSET__DCGzD01m__"